import React from 'react';

export const HorizontalSeparator = () => <div className="bg-aux-gray w-full h-px" />;
